import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  MODAL_BACKGROUND_COLOR,
  MODAL_TEXT_COLOR,
  MODAL_TITLE_BACKGROUND_COLOR,
  MODAL_TITLE_TEXT_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    background: MODAL_BACKGROUND_COLOR,
    color: MODAL_TEXT_COLOR,
    borderRadius: 4,
    outline: 'none',
    zIndex: 5,
    transform: 'translate(-50%, -50%)',
    minWidth: 300,
    maxWidth: '100%',
    maxHeight: '100vh',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)'
    // overflow: 'auto'
  },
  overlayBase: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5
  },
  close: {
    fontSize: 15,
    fontWeight: 'bold',
    cursor: 'pointer',
    margin: '-10px -10px 0 auto'
  },
  title: {
    display: 'flex',
    flexShrink: 0,
    padding: 20,
    backgroundColor: MODAL_TITLE_BACKGROUND_COLOR,
    color: MODAL_TITLE_TEXT_COLOR,
    textTransform: 'uppercase',
    fontSize: '1.1em',
    fontWeight: 600,
    marginBottom: -1
  },
  body: {
    display: 'flex',
    height: '100%',
    padding: 0
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.styles.js